import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; 
import { verifyHardwareMatch } from '../services/MobileBridge';

const GOLD = '#B8860B';
const NAVY = '#001F3F';

export default function BiometricUnlock({ deviceId }) {
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const navigate = useNavigate();

  const handleHardwareVerify = async () => {
    setIsAuthenticating(true);
    
    try {
      /**
       * WEB-SAFE AUTHENTICATION
       * We verify the unique hardware signature (GPU/Fingerprint) generated in App.jsx.
       * Native mobile biometrics are skipped to ensure Vercel build compatibility.
       */
      const isTrusted = await verifyHardwareMatch(deviceId);
      
      if (isTrusted) {
        navigate('/dashboard');
      } else {
        alert("Security Alert: This device is not tethered to this profile.");
        navigate('/login');
      }
    } catch (error) {
      console.error("Hardware verification error:", error);
      alert("Authentication error. Please use your access code.");
      navigate('/login');
    } finally {
      setIsAuthenticating(false);
    }
  };

  useEffect(() => {
    // Auto-trigger the hardware check after a short delay
    const timer = setTimeout(() => {
      handleHardwareVerify();
    }, 800);
    return () => clearTimeout(timer);
  }, [deviceId]);

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>ESDRAS HARDWARE SHIELD</h2>
      
      <div 
        onClick={handleHardwareVerify} 
        style={styles.lockIcon}
      >
        <div style={{
          ...styles.pulseCircle, 
          animation: isAuthenticating ? 'pulse 2s infinite' : 'none'
        }} />
        <span style={{fontSize: '50px'}} role="img" aria-label="lock">👤</span> 
      </div>

      <p className="loader-text" style={styles.status}>
        {isAuthenticating ? "Verifying Hardware Signature..." : "Locked • Tap to Unlock"}
      </p>

      <button 
        onClick={() => navigate('/login')} 
        style={styles.fallbackBtn}
      >
        USE ACCESS CODE
      </button>

      {/* Internal CSS for the Shield Pulse */}
      <style>{`
        @keyframes pulse {
          0% { transform: scale(1); opacity: 0.3; }
          50% { transform: scale(1.1); opacity: 0.6; }
          100% { transform: scale(1); opacity: 0.3; }
        }
      `}</style>
    </div>
  );
}

const styles = {
  container: { 
    height: '100vh', 
    backgroundColor: NAVY, 
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center', 
    justifyContent: 'center',
    color: '#fff',
    fontFamily: 'sans-serif'
  },
  title: { color: GOLD, fontWeight: '900', letterSpacing: '3px', marginBottom: '50px', textAlign: 'center', padding: '0 20px' },
  lockIcon: { 
    width: '120px', 
    height: '120px', 
    borderRadius: '60px', 
    border: `2px solid ${GOLD}`, 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    cursor: 'pointer',
    position: 'relative'
  },
  pulseCircle: { 
    position: 'absolute', 
    width: '140px', 
    height: '140px', 
    borderRadius: '70px', 
    border: `1px solid ${GOLD}`, 
    opacity: 0.3 
  },
  status: { marginTop: '30px', opacity: 0.8, letterSpacing: '1px', fontWeight: 'bold' },
  fallbackBtn: { 
    background: 'none', 
    border: 'none', 
    color: GOLD, 
    marginTop: '40px', 
    textDecoration: 'underline', 
    fontWeight: 'bold', 
    cursor: 'pointer' 
  }
};
    
